import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { isEmpty, pick } from "lodash";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import InternalLoader from "../../component/InternalLoader";

const Profile = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({});

  useEffect(() => {
    if (!isEmpty(profileData)) {
      setValue("email", profileData?.email);
      setValue("firstName", profileData?.firstName);
      setValue("lastName", profileData?.lastName);
    }
  }, [profileData]);
  const onSubmit = async (request) => {
    setLoader(true);
    let obj = pick(request, ["email", "firstName", "lastName"]);
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.userProfileUpdate,
        { ...obj }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users?.message);
          setLoader(false);
        } else {
          toast.error(response_users?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="personalCenter">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-index mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{ paddingLeft: "0" }} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">My Account</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="am-flexbox am-flexbox-align-middle flex-text">
            <div className="am-flexbox-item">
              <div className="personal-name">
                <span>
                  {/* react-text: 5998 */}Username{/* /react-text */}
                  {/* react-text: 5999 */}:&nbsp;&nbsp;{/* /react-text */}
                </span>
                <span>{profileData?.username}</span>
              </div>
            </div>
          </div>
          <div className="account-form n-form-content ">
            <div className="account-form-group  ">
              <div className="false mc-account-list hide-data-svg">
                <svg className="am-icon am-icon-mcNickname_d49ccbbb am-icon-md txt-svg">
                  <use xlinkHref="#mcNickname_d49ccbbb" />
                </svg>
                <input
                  type="text"
                  placeholder="Please enter your first name"
                  {...register("firstName")}
                />
              </div>
            </div>{" "}
            <div className="account-form-group  ">
              <div className="false mc-account-list hide-data-svg">
                <svg className="am-icon am-icon-mcNickname_d49ccbbb am-icon-md txt-svg">
                  <use xlinkHref="#mcNickname_d49ccbbb" />
                </svg>
                <input
                  type="text"
                  placeholder="Please enter your last name"
                  {...register("lastName")}
                />
              </div>
            </div>
            <div className="account-form-group  ">
              <div className="false mc-account-list hide-data-svg">
                <svg className="am-icon am-icon-mcEmail_edd039ae am-icon-md txt-svg ">
                  <use xlinkHref="#mcEmail_edd039ae" />
                </svg>
                <input
                  type="email"
                  placeholder="Please enter your email"
                  {...register("email", {
                    required: "Please enter email",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address.",
                    },
                  })}
                />
              </div>{" "}
              {errors.email && errors.email.message && (
                <div className="account-errors">
                  <strong> {errors.email.message}</strong>
                </div>
              )}
            </div>
            {/* <div className="account-form-group  ">
              <div className="false mc-account-list hide-data-svg">
                <svg className="am-icon am-icon-mcPayeeName_d3e50d87 am-icon-md txt-svg hide-data-svg">
                  <use xlinkHref="#mcPayeeName_d3e50d87" />
                </svg>
                <input
                  type="text"
                  name="payee"
                  placeholder="Please enter your Full Name"
                />
              </div>
              <div className="account-errors">
                <span className="tips">
                  Please enter your correct name as it appears on your National
                  Identity card. Do not use any wrong username, as it may cause
                  problems for you.
                </span>
                <strong />
              </div>
            </div> */}
            {/* <div className="account-form-group  ">
              <div className="country-code">
                <div className="false mc-account-list hide-data-svg">
                  <svg className="am-icon am-icon-mcMobile_673c6c76 am-icon-md txt-svg">
                    <use xlinkHref="#mcMobile_673c6c76" />
                  </svg>
                  <input type="tel" name="mobile" placeholder="Phone number" />
                </div>
              </div>
              <div className="account-errors">
                <strong />
              </div>
            </div> */}
            <div className="account-tip">
              <div className="tip-title">We care about your privacy</div>
              <div className="tip-content">
                All the user data are encrypted to ensure your personal privacy
                is protected.
              </div>
            </div>
            <button
              role="button"
              type="submit"
              style={{ width: "100%" }}
              className="btn-success am-button"
              aria-disabled="false"
            >
              <span>Submit</span>
            </button>
          </div>
          <div className="mc-code-box hide">
            <div className="code-form">
              <h3 className="title">Verify Code</h3>
              <div className="form-group">
                <div className="country-code">
                  <div
                    className="input-group"
                    style={{
                      "-webkit-flex": "0 1 0%",
                      "-ms-flex": "0 1 0%",
                      flex: "0 1 0%",
                    }}
                  >
                    {/* react-empty: 6007 */}
                  </div>
                  <div className="input-group">
                    <label>Mobile number</label>
                    <input
                      type="text"
                      inputMode="tel"
                      placeholder="Please fill in your phone number"
                      style={{
                        "-webkit-transition": "0.15s linear",
                        transition: "0.15s linear",
                      }}
                    />
                    <div className="account-errors mobileNum-tips" />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="code-input"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  placeholder="Verification code"
                  defaultValue
                />
                <a className="send-code btn-success">Send</a>
              </div>
              <div className="code-tip">
                *Verification code will be automatically sent to the bound
                mobile number
              </div>
              <div className="form-group">
                <button
                  role="button"
                  type="submit"
                  style={{ width: "100%" }}
                  className="submit btn-success am-button am-button-disabled"
                  aria-disabled="true"
                >
                  <span>Submit</span>
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      {loader && <InternalLoader />}
    </div>
  );
};

export default Profile;
